import { render, staticRenderFns } from "./editActions.vue?vue&type=template&id=10f13899"
import script from "./editActions.vue?vue&type=script&lang=js"
export * from "./editActions.vue?vue&type=script&lang=js"
import style0 from "./editActions.vue?vue&type=style&index=0&id=10f13899&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports